// extracted by mini-css-extract-plugin
export default {"base":"UserMultisectorsPage_base__ut-ZR","header":"UserMultisectorsPage_header__Jusze","goback":"UserMultisectorsPage_goback__0kp2k","title":"UserMultisectorsPage_title__ouF2C"};